import React from 'react';
import ReactPlayer from 'react-player';
import { reloadIfLinksExpired } from '../utils/expiredLinks';

/**
 * Unified video player for all formats (MP4, MOV, MXF, HLS, etc.).
 * Prefers the lowest available transcoded quality variant to ensure
 * broad browser compatibility, falling back to the raw URL.
 */
function VideoPlayer({ qualityTypeArray, url, poster, autoPlay = false, onPlay, onContextMenu, style }) {
  const src =
    qualityTypeArray?.find((q) => q.qualitytype === '360')?.qualityvideoname ||
    qualityTypeArray?.[0]?.qualityvideoname ||
    url;

  return (
    <ReactPlayer
      url={src}
      playing={autoPlay}
      controls
      width="100%"
      height="100%"
      style={{ maxHeight: '80vh', backgroundColor: '#000', ...style }}
      config={{
        file: {
          attributes: {
            poster,
            onContextMenu,
            controlsList: 'nodownload',
            className: 'media-no-save',
          },
        },
      }}
      onPlay={onPlay}
      onError={() => reloadIfLinksExpired(src)}
    />
  );
}

export default VideoPlayer;
